module.exports = __webpack_public_path__ + "static/media/tapas.088917e5.jpg";